import { useMutation } from 'react-query';
import {
  createOpenDoorEventAsync,
  getAllEventByLicenseAsync,
  getAllEventsCountByDeviceIdAsync,
  getAllTotalEventAsync,
} from '../../index';

export const useGetAllEventsCountByDeviceIdAsync = () =>
  useMutation(getAllEventsCountByDeviceIdAsync);
export const useCreateOpenDoorEventAsync = () =>
  useMutation(createOpenDoorEventAsync);

export const useGetOpenDoorEventAsync = () =>
  useMutation(getAllEventByLicenseAsync);

